
<template>
	<div class="table-wrapper">
		<div class="navbar-white">
			<Navbar
				class="desktop-center"
				:logoSrc="$logoSrc"
				:backButton="false"
			/>
		</div>
		<Banner />
		<div class="table-page-content">
			<div>
				<h2 class="start-title">{{ locationTitle }}</h2>
				<h3 v-if="locationSubtitle" class="start-table">
					{{ locationSubtitle }}
				</h3>
			</div>
			<div class="location-input-wrapper">
				<label class="location-label">{{ locationPrefix }}</label>
				<input
					:type="'text'"
					class="form-control location-input"
					placeholder="#"
					autofocus
					v-validator="locationRegex"
					v-on-enter="onEnter"
					@change="setTable"
				/>
			</div>
			<router-link
				:to="menuPath"
				tag="button"
				class="button button-primary"
			>
				Continue
			</router-link>
		</div>
	</div>
</template>

<style scoped>
.table-wrapper {
	display: flex;
	height: 100%;
	flex-direction: column;
}

.table-page-content {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	flex: 1;
	padding: 0 18px 22px 18px;
}

.start-title {
	color: var(--gR-base-90);
	font-size: 24px;
	margin-bottom: 20px;
	letter-spacing: -0.5px;
	font-weight: 700;
}

.start-table {
	font-size: 14px;
	color: var(--sk-grey3);
	margin-bottom: 0;
}

.location-input {
	font-size: 50px;
	width: 135px;
	height: 75px;
	text-align: center;
	display: inline-block;
	border-radius: 5px;
}

.location-input:focus {
	border: 1px solid var(--gR-teal-70) !important;
}

.location-label {
	font-weight: 800;
	margin-right: 18px;
	font-size: 50px;
	color: var(--gR-base-90);
	margin-bottom: 0;
}

.button {
	max-width: 205px;
}

.location-input-wrapper {
	margin: 33px 0;
	flex: 1;
	display: flex;
	align-items: center;
}
</style>

<script>
import { BusinessType } from "@reef-os/utils/enums/businessType"
import voucherMixin from "@/mixins/voucher-mixin"
import locationNameFormatterMixin from "@/mixins/location-name-formatter-mixin"
import Banner from "@/components/Banner.vue"
import Navbar from "@/components/navbars/Navbar.vue"

export default {
	name: "Table",
	mixins: [voucherMixin, locationNameFormatterMixin],
	components: {
		Navbar,
		Banner
	},
	computed: {
		type() {
			return this.$store.state.business
				? this.$store.state.business.type
				: null
		},
		hasTable() {
			return this.type == BusinessType.BAR
		},
		menuPath() {
			let path = `/${this.$route.params.slug}/menu`
			if (
				this.$store.state.table != undefined &&
				this.$store.state.table > 0
			) {
				path = `${path}/${this.$store.state.table}`
			}
			return path
		},
		locationRegex() {
			switch (this.type) {
				case BusinessType.RESIDENTIAL:
				case BusinessType.HOTEL:
				case BusinessType.COWORKING: {
					return /^[a-zA-Z0-9]{1,15}$/
				}
				default: {
					return /^[a-zA-Z0-9]{1,4}$/
				}
			}
		},
		locationTitle() {
			switch (this.type) {
				case BusinessType.HOTEL: {
					return "What is your room number?"
				}
				case BusinessType.RESIDENTIAL: {
					return "What is your apartment number?"
				}
				case BusinessType.COWORKING: {
					return "What is your suite number?"
				}
				default: {
					return "Where are you sitting?"
				}
			}
		},
		locationSubtitle() {
			switch (this.type) {
				case BusinessType.HOTEL:
				case BusinessType.RESIDENTIAL:
				case BusinessType.COWORKING: {
					return null
				}
				default: {
					return "Don’t worry if you can’t find your table number! You can still place an order without one"
				}
			}
		},
		locationPrefix() {
			return this.$options.filters.locationName(this.type)
		}
	},
	methods: {
		setTable: function (event) {
			this.$store.dispatch("setCurrentTable", event.target.value)
			this.$store.dispatch("sendMixpanelEvent", { msg: "Select Table" })
		},
		onEnter() {
			this.$router.push({ path: this.menuPath })
		}
	},
	created: function () {
		this.$store.dispatch("clearOrder")
		if (
			this.$route.query.code != undefined &&
			this.$route.query.code != ""
		) {
			this.validateVoucher()
		}
	}
}
</script>